import React from 'react';
import { Hero } from '../components/Hero';
import { ValidationSnapshot } from '../components/ValidationSnapshot';
import { MarketGap } from '../components/MarketGap';
import { ProofStrip } from '../components/ProofStrip';
import { Problem } from '../components/Problem';
import { TaglineExplainer } from '../components/TaglineExplainer';
import { FrontierGatewayTeaser } from '../components/FrontierGatewayTeaser';
import { InternalRunnerTeaser } from '../components/InternalRunnerTeaser';
import { Integrations } from '../components/Integrations';
import { ThreatCenterTeaser } from '../components/ThreatCenterTeaser';
import { WhatPeriscanValidates } from '../components/WhatPeriscanValidates';
import { HomeHowItWorks } from '../components/HomeHowItWorks';
import { PeriscanOperators } from '../components/PeriscanOperators';
import { Competitive } from '../components/Competitive';
import { Safety } from '../components/Safety';
import { WhyNow } from '../components/WhyNow';
import { FounderCard } from '../components/FounderCard';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { SectionStage } from '../components/SectionStage';
export function Home() {
  return <>
      <Hero data-id="element-1539" />

      <SectionStage fx="ripple" data-id="element-1540">
        <ValidationSnapshot data-id="element-1541" />
      </SectionStage>

      <SectionStage fx="matrix" data-id="element-1542">
        <MarketGap data-id="element-1543" />
      </SectionStage>

      <SectionStage fx="beams" data-id="element-1544">
        <ProofStrip data-id="element-1545" />
      </SectionStage>

      <SectionStage fx="squares" data-id="element-1546">
        <Problem data-id="element-1547" />
      </SectionStage>

      <SectionStage fx="spotlight" data-id="element-1548">
        <TaglineExplainer data-id="element-1549" />
      </SectionStage>

      <SectionStage fx="orbit" data-id="element-1550">
        <FrontierGatewayTeaser data-id="element-1551" />
      </SectionStage>

      <SectionStage fx="circuit" data-id="element-1552">
        <InternalRunnerTeaser data-id="element-1553" />
      </SectionStage>

      <SectionStage fx="constellation" data-id="element-1554">
        <Integrations data-id="element-1555" />
      </SectionStage>

      <SectionStage fx="lightning" data-id="element-1556">
        <ThreatCenterTeaser data-id="element-1557" />
      </SectionStage>

      <SectionStage fx="circuit" data-id="element-1558">
        <WhatPeriscanValidates data-id="element-1559" />
      </SectionStage>

      <SectionStage fx="threads" data-id="element-1560">
        <HomeHowItWorks data-id="element-1561" />
      </SectionStage>

      {/* Periscan Operators — rendered without SectionStage so the cinematic
                        blur/opacity transform doesn't dampen the radar sweep behind it. */}
      <PeriscanOperators data-id="element-1562" />

      <SectionStage fx="lightning" data-id="element-1563">
        <Competitive data-id="element-1564" />
      </SectionStage>

      <SectionStage fx="constellation" data-id="element-1565">
        <Safety data-id="element-1566" />
      </SectionStage>

      {/* Brand Legacy — rendered without SectionStage so the cinematic
                          blur/opacity transform doesn't dampen the radar sweep. */}
      <WhyNow data-id="element-1567" />

      <SectionStage fx="glow-orbs" data-id="element-1568">
        <FounderCard data-id="element-1569" />
      </SectionStage>

      <SectionStage fx="squares" data-id="element-1570">
        <FAQ data-id="element-1571" />
      </SectionStage>

      <SectionStage fx="hyperspeed-aurora" data-id="element-1572">
        <FinalCTA data-id="element-1573" />
      </SectionStage>
    </>;
}